import { Pipe, PipeTransform } from '@angular/core';
import { Color } from '../models/color';

@Pipe({
    name: 'color',
    standalone: true
})
export class ColorPipe implements PipeTransform {

    transform(color: Color, args?: any): string {

        if (!color) {
            return 'gold';
        }

        return color.getColorString();
    }

}
